(function ($) {
  $(window).ready(function () {
    const verificationContainer = $('#phone-verification');
    const verificationContainerHeading = $('#phone-verification-heading');
    const verificationStep1 = $('#phone-verification-step-1');
    const verificationStep1Button = $('#phone-verification-step-1-button');
    const verificationStep2 = $('#phone-verification-step-2');
    const verificationStep2Form = $('#phone-verification-step-2-form');
    const verificationStep2Phone = $('#phone-verification-step-2-phone');
    const verificationStep2Submit = $('#phone-verification-step-2-submit');
    const verificationStep2Error = $('#phone-verification-step-2-error');
    const verificationBackToStep2 = $('#phone-verification-back-to-step-2');
    const verificationStep3 = $('#phone-verification-step-3');
    const verificationStep3Form = $('#phone-verification-step-3-form');
    const verificationStep3RequestID = $('#phone-verification-step-3-request-id');
    const verificationStep3Phone = $('#phone-verification-step-3-phone');
    const verificationStep3Code = $('#phone-verification-step-3-code');
    const verificationStep3Submit = $('#phone-verification-step-3-submit');
    const verificationStep3Error = $('#phone-verification-step-3-error');
    const verificationStep4 = $('#phone-verification-step-4');

    // Handle step 1: Start process
    verificationStep1Button.on('click', (e) => {
      verificationStep1.hide();
      verificationStep2.show();
      enableAutoformatListener();
    });

    // Handle step 2: Submit phone number
    verificationStep2Form.on('submit', (e) => {
      e.preventDefault();

      // Disable submit button and hide previous error notice if shown
      verificationStep2Error.hide();
      verificationStep2Submit.prop('disabled', true);

      // Build the params object for Phone Verification
      const params = {
        p1: verificationContainer.data('meetingId'),
        p2: verificationStep2Phone.val().replace(/[^0-9]/gi, ''),
        p3: window.dfApi.uuidv4(), // Specs: "Pass a random UUID"
        p4: '4f53432d4f534d',      // Specs: this hardcoded value
        p5: 'EN',                  // Specs: either EN or ES (current project scope is EN only)
        p6: 1                      // Specs: this hardcoded value
      }

      // Perform and process API request
      window.dfPlatform.requestOSCReminderViaSMS(params)
        .then(values => {
          const codeReturnedByPlatform = parseInt(values.healthtxt_message.code);
          switch (codeReturnedByPlatform) {
            case 0: // Code for: Success
              // Make sure the meetingregistrant_id is defined in the response message
              if (window.dfApi.hasOwnNestedProperty(values, 'healthtxt_message.message_body.MeetingRegistrant.meetingregistrant_id')) {
                // Save ID for next step
                verificationStep3RequestID.val(values.healthtxt_message.message_body.MeetingRegistrant.meetingregistrant_id);
                // Update phone number in description for next step
                verificationStep3Phone.html(verificationStep2Phone.val().replace(/[^0-9]/gi, ''));
                // Display next step form
                verificationStep2.hide();
                verificationStep3.show();
                // Remove input event listener
                verificationStep2Phone.off('keyup');
              } else {
                // The API has returned success code but it does not contain the required property
                // This will only happen if the API is "broken"
                throw 'An error occurred processing your data, please try again later.';
              }
              break;
            case 1001: // Code for: User already exists
              throw 'You are already signed up to receive text reminders for this meeting.';
              break;
            default:
              // Unknown error code
              throw 'Please try again.';
          }
        })
        .catch((error) => {
          // Display error
          verificationStep2Error.html(error);
          verificationStep2Error.show();
          // Enable button again to allow the user repeat the action
          verificationStep2Submit.prop('disabled', false);
        });
    });

    // Handle step 3: Verify phone number
    verificationStep3Form.on('submit', (e) => {
      e.preventDefault();

      // Disable submit button and hide previous error notice if shown
      verificationStep3Error.hide();
      verificationStep3Submit.prop('disabled', true);

      // Build the params object for Phone Verification
      const params = {
        p1: verificationStep3RequestID.val(),
        p2: '4f534d636865636b',
        p3: verificationStep3Code.val(),
        p4: 1, // Specs: this hardcoded value
        p5: verificationContainer.data('meetingId')
      }

      window.dfPlatform.verifyOSCReminderViaSMS(params)
        .then(values => {
          const codeReturnedByPlatform = parseInt(values.healthtxt_message.code);
          switch (codeReturnedByPlatform) {
            case 0:  // Code for: Success
              // Display next step form
              verificationStep3.hide();
              verificationContainerHeading.find('#phone-verification-heading-during-process').hide();
              verificationContainerHeading.find('#phone-verification-heading-when-finished').show();
              verificationStep4.show();
              break;
            case 4001: // Code for: Wrong PIN
              throw 'Incorrect PIN Code';
              break;
            default:
              // Unknown error code
              throw 'Please try again.';
          }
        })
        .catch((error) => {
          // Display error
          verificationStep3Error.html(error);
          verificationStep3Error.show();
          // Enable button again to allow the user repeat the action
          verificationStep3Submit.prop('disabled', false);
        });

    });

    // Handle "go back to step 2" link
    verificationBackToStep2.on('click', (e) => {
      // Reset form and enable button
      verificationStep2Phone.val('');
      verificationStep2Submit.prop('disabled', false);
      // Switch displayed screen
      verificationStep3.hide();
      verificationStep2.show();
      enableAutoformatListener();
    });

    /**
     * Responsible for formatting the input field phone number
     */
    function formatToPhone(event) {
      const input = event.target.value.replace(/\D/g, '').substring(0, 10); // First ten digits of input only
      const zip = input.substring(0, 3);
      const middle = input.substring(3, 6);
      const last = input.substring(6, 10);

      if (input.length > 6) {
        event.target.value = `(${zip}) ${middle} - ${last}`;
      } else if (input.length > 3) {
        event.target.value = `(${zip}) ${middle}`;
      } else if (input.length > 0) {
        event.target.value = `(${zip}`;
      }
    };

    /**
     * Responsible for adding the phone autoformat event listener to the input field
     */
    function enableAutoformatListener() {
      verificationStep2Phone.on('keyup', formatToPhone);
    }

  });
})(jQuery);
